import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7aa5d17e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "image-overlay"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_img = _resolveComponent("b-img");
  const _component_stroked_rounded_link_icon = _resolveComponent("stroked-rounded-link-icon");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['hoverable-image', {
      active: $props.active
    }])
  }, [_createVNode(_component_b_img, {
    lazy: "",
    src: $props.image ?? '/assets/images/amazon-logo-transparent.svg',
    height: $props.height,
    width: $props.width
  }, null, 8, ["src", "height", "width"]), _createElementVNode("div", _hoisted_1, [_createVNode(_component_stroked_rounded_link_icon, {
    width: $props.width / 2,
    height: $props.height / 2,
    color: "#FFFFFF"
  }, null, 8, ["width", "height"])])], 2);
}